export default "__VITE_PUBLIC_ASSET__1ef7b098__"